import { useLocation } from '@app/router';

const useIsTransactionFlow = () => {
  const location = useLocation();
  return (
    location?.pathname.includes('/buy') || location?.pathname.includes('/sell')
  );
};

export default useIsTransactionFlow;
